import { render, staticRenderFns } from "./PriceCategory.vue?vue&type=template&id=26babede&"
import script from "./PriceCategory.vue?vue&type=script&lang=ts&"
export * from "./PriceCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports